export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/v4/like/icon-like-off-db8248755f2f2b462804a073516be174.svg";